import axios from 'axios';
import { getToken } from './auth';
import { CONFIG } from '../config/config';

const API_URL = CONFIG.SERVER_URL;

// Type definitions
export interface ApplicableMetricLevelDetail {
  id: number;
  name: string;
  display_label: string;
  is_period_based: boolean;
  level_number: number;
}

export interface ReviewEntityType {
  id?: number;
  name: string;
  display_label: string;
  category: string;
  description: string;
  review_dimension_names?: string[];
  associated_review_dimensions?: number[];
  associated_review_dimension_names?: string[];
  metric_level_names?: string[];
  applicable_metric_levels?: number[];
  applicable_metric_level_details?: ApplicableMetricLevelDetail[];
  created_by?: any; // Could be number or user object from backend
  updated_by?: any;
  created_at?: string;
  updated_at?: string;
}

export interface ReviewDimension {
  id: number;
  name: string;
  description: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
}

// Get all review entity types
export const getAllReviewEntityTypes = async (): Promise<ReviewEntityType[]> => {
  try {
    const response = await axios.get(`${API_URL}/review_entity_types`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching review entity types:', error);
    throw error;
  }
};

// Delete a review entity type by name
export const deleteReviewEntityType = async (name: string): Promise<void> => {
  try {
    await axios.delete(`${API_URL}/review_entity_types/${name}`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    });
  } catch (error) {
    console.error(`Error deleting review entity type ${name}:`, error);
    throw error;
  }
};

// Update a review entity type
export const updateReviewEntityType = async (
  originalName: string, 
  entityType: ReviewEntityType
): Promise<ReviewEntityType> => {
  try {
    const response = await axios.put(
      `${API_URL}/review_entity_types/${originalName}`, 
      entityType,
      { headers: { Authorization: `Bearer ${getToken()}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating review entity type:', error);
    throw error;
  }
};

// Create a new review entity type
export const createReviewEntityType = async (
  entityType: ReviewEntityType
): Promise<ReviewEntityType> => {
  try {
    const response = await axios.post(
      `${API_URL}/review_entity_types`, 
      entityType,
      { headers: { Authorization: `Bearer ${getToken()}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating review entity type:', error);
    throw error;
  }
};

// Get all review dimensions
export const getAllReviewDimensions = async (): Promise<ReviewDimension[]> => {
  try {
    const response = await axios.get(`${API_URL}/review_dimensions`, {
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching review dimensions:', error);
    throw error;
  }
};
